import * as React from "react"
import { ButtonHTMLAttributes } from 'react'

import { Link } from "react-router-dom"

interface ButtonProps {
  className?: string
  variant?: "white"
  arrow?: boolean
  handle?: () => void
  buttonProps?: ButtonHTMLAttributes<HTMLButtonElement>
}

export interface LinkButtonProps {
  className?: string
  variant?: "white" | "black"
  arrow?: boolean
  route: string
  handle?: () => void
}

export const Button: React.StatelessComponent<ButtonProps> = props => (
  <button
    className={`button${props.arrow ? " button--arrow" : ""} ${props.variant ? props.variant : ""} ${
      props.className ? props.className : ""
    }`}
    onClick={() => props.handle()}
    {...props.buttonProps}
  >
    {props.children}
  </button>
)

export const LinkButton: React.StatelessComponent<LinkButtonProps> = props => {
  let className = `button${props.arrow ? " button--arrow" : ""} ${props.variant ? props.variant : ""} ${
    props.className ? props.className : ""
  }`
  let onClick = () => props.handle && props.handle()
  let parser = document.createElement("a")
  parser.href = props.route
  let decodedUrl = `${parser.origin}${parser.pathname}${decodeURIComponent(parser.search)}`

  return props.route.substr(0, 4) === "http" ? (
    <a className={className} href={decodedUrl} target={"_blank"} onClick={onClick}>
      {props.children}
    </a>
  ) : (
    <Link className={className} to={props.route} onClick={onClick}>
      {props.children}
    </Link>
  )
}
